import { createContext, useState, useContext } from 'react';  
  
export const AuthContext = createContext(null);  
  
export const AuthProvider = ({ children }) => {  
  const [user, setUser] = useState(null);  
  const [token, setToken] = useState(localStorage.getItem('token'));  
  
  const login = (userData, token) => {  
    setUser(userData);  
    setToken(token);  
    localStorage.setItem('token', token);  
    localStorage.setItem('user', JSON.stringify(userData));  
  };  
  
  const logout = () => {  
    setUser(null);  
    setToken(null);  
    localStorage.removeItem('token');  
    localStorage.removeItem('user');  
  };  
  
  return (  
    <AuthContext.Provider value={{ user, token, login, logout }}>  
      {children}  
    </AuthContext.Provider>  
  );  
};

export const useAuth = () => useContext(AuthContext);  